import EmailPreferencesApp from './email-preferences-app'

export default EmailPreferencesApp
